import React, { useState } from "react";
import { AppListing } from "../../../../components/appListing";
import { FaComments } from "react-icons/fa";
import moment from "moment";
import MainPageDialog from "../../../../components/mainPageDialog";

const CareplanAllergies = ({ listData = [], loading = false }) => {
  const [commentsDialog, setCommentsDialog] = useState(false);
  const [commentsText, setCommentsText] = useState("");

  const handleComments = (item) => {
    setCommentsText(item?.comments);
    setCommentsDialog(true);
  };

  const AllergiesCols = [
    { title: "Allergy", key: "name" },
    {
      title: "Type",
      key: "allergen_type",
      getData: (item) =>
        item?.allergen_type ? (
          <div className="capitalize">
            {item?.allergen_type.replace(/_/g, " ")}
          </div>
        ) : (
          "-"
        ),
    },
    { title: "Reaction", key: "reaction" },
    {
      title: "Severity",
      key: "severity",
      getData: (item) =>
        item?.severity ? (
          <div className="capitalize">{item?.severity.replace(/_/g, " ")}</div>
        ) : (
          "-"
        ),
    },
    {
      title: "Onset",
      key: "onset_date",
      getData: (data) => {
        const originalDate =
          data?.onset_date !== "" ? moment(data?.onset_date).format("l") : "";
        return originalDate;
      },
    },
    {
      title: "Comments",
      key: "history",
      colClass: "col-md-1 text-center",
      getData: (item) =>
        item?.comments !== "" && (
          <div className="flex w-[100%] items-start justify-start px-2 text-blue-500 text-lg hover:text-blue-900">
            <FaComments />
          </div>
        ),
      onClick: (item) => handleComments(item),
    },
  ];

  return (
    <>
      <div className="py-2">
        <AppListing
          loading={loading}
          listData={listData}
          cols={AllergiesCols}
        />
      </div>
      {commentsDialog && (
        <MainPageDialog
          title="Comments"
          modalSize="md"
          maxHeight={true}
          footerList={[
            {
              title: "Cancel",
              type: "cancel",
              action: () => setCommentsDialog(false),
            },
          ]}
          onCancelHandler={() => setCommentsDialog(false)}
        >
          {commentsText === "" ? "No comments added." : commentsText}
        </MainPageDialog>
      )}
    </>
  );
};

export default CareplanAllergies;
